import { supabase } from "./supabase";

export async function fetchPublishedArticles() {
  const { data, error } = await supabase
    .from("articles")
    .select("*")
    .eq("published", true)
    .order("created_at", { ascending: false });

  if (error) {
    console.error("❌ Erreur Supabase :", error.message);
    return [];
  }

  console.log("✅ Données brutes Supabase :", data);
  return data;
}

export async function fetchArticleBySlug(slug: string) {
  const { data, error } = await supabase
    .from('articles')
    .select('*')
    .eq('slug', slug)
    .eq('published', true)
    .single();

  if (error) {
    console.error("Erreur Supabase :", error);
    return null;
  }

  return data;
}

export async function fetchFeaturedArticles() {
  const { data, error } = await supabase
    .from('articles')
    .select('*')
    .eq('published', true)
    .order('published_date', { ascending: false })
    .limit(3);

  if (error) {
    console.error("Erreur Supabase :", error);
    return [];
  }

  return data;
}

export async function updateArticleById(id: string, data: Partial<Article>) {
  const { error } = await supabase.from("articles").update(data).eq("id", id);
  if (error) throw new Error("Erreur update : " + error.message);
}

export async function fetchArticlesByCategory(category: string) {
  const { data, error } = await supabase
    .from('articles')
    .select('*')
    .eq('published', true)
    .eq('category', category)
    .order('published_date', { ascending: false });

  if (error) {
    console.error("Erreur Supabase :", error);
    return [];
  }

  return data;
}

interface Article {
  id: string;
  title: string;
  content: string;
  excerpt?: string;
  image_url?: string;
  published: boolean;
  published_date?: string;
  author?: string;
  slug?: string;
  category?: string;
}